import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
const api = process.env.REACT_APP_API_ADDRESS;

export const supportApi = createApi({
    reducerPath: 'supportApi',
    tagTypes: ['Message', 'Support', "Question", "Settings"],
    baseQuery: fetchBaseQuery({
        baseUrl: api,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem("token");
            if(token) headers.set("token", token);
            return headers;
        }
    }),
    endpoints: (builder) => ({

        getSupports: builder.mutation({
            query: (params) => ({
                url: `/api/supports/get`,
                method: "GET",
                params
            }),
            invalidatesTags: ["Support"]
        }),

        getSupport: builder.query({
            query: (params) => ({
                url: `/api/support/get`,
                method: "GET",
                params
            }),
            providesTags: ["Support"]
        }),

        createQuestion: builder.mutation({
            query: (body) => ({
                url: `/api/support/question/create`,
                method: "POST",
                body
            }),
            invalidatesTags: ["Question"]
        }),

        updateQuestion: builder.mutation({
            query: (body) => ({
                url: `/api/support/question/update`,
                method: "POST",
                body
            }),
            invalidatesTags: ["Question"]
        }),

        getQuestions: builder.query({
            query: (params) => ({
                url: `/api/support/question/get`,
                method: "GET",
                params
            }),
            providesTags: ["Question"]
        }),

        deleteQuestion: builder.mutation({
            query: (body) => ({
                url: `/api/support/question/delete`,
                method: "POST",
                body
            }),
            invalidatesTags: ["Question"]
        }),

        getQuestion: builder.mutation({
            query: (params) => ({
                url: `/api/support/question/get`,
                method: "GET",
                params
            }),
            invalidatesTags: ["Question"]
        }),

        saveSettings: builder.mutation({
            query: (body) => ({
                url: `/api/support/settings/save`,
                method: "POST",
                body
            }),
            invalidatesTags: ["Settings"]
        }),

        getSettings: builder.query({
            query: (params) => ({
                url: `/api/support/settings/get`,
                method: "GET",
                params
            }),
            providesTags: ["Settings"]
        }),

        readSupport: builder.mutation({
            query: (body) => ({
                url: `/api/support/read`,
                method: "POST",
                body
            })
        }),

    })
})

export const {
    useGetSupportsMutation,
    useGetSupportQuery,
    useCreateQuestionMutation,
    useGetQuestionMutation,
    useGetQuestionsQuery,
    useUpdateQuestionMutation,
    useDeleteQuestionMutation,
    useGetSettingsQuery,
    useSaveSettingsMutation,
    useReadSupportMutation
} = supportApi;